/**
 * @deprecated
 * @description BorderRadiusSize를 사용해주세요.
 */
export type CornerRadiusSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'full';
export type BorderRadiusSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'full';
export type ShadowScale = 'low' | 'medium' | 'high';

interface Shapes {
  border_radius: Record<BorderRadiusSize, `border-radius: ${number}px;`>;
  shadow: Record<ShadowScale, `box-shadow: ${string};`>;
}

const BASE_OFFSET_VALUE = 4;

function getBorderRadiusStyle(usage_with_size: BorderRadiusSize): `border-radius: ${number}px;` {
  return `border-radius: ${border_radius_styles_with_size[usage_with_size]}px;`;
}
/**
 * @deprecated
 * @description border_radius_styles_with_size 혹은 shapes.border_radius를 사용해주세요.
 */
export const corner_radius_styles_with_size: Record<BorderRadiusSize, number> = {
  xsmall: BASE_OFFSET_VALUE,
  small: BASE_OFFSET_VALUE * 2,
  medium: BASE_OFFSET_VALUE * 3,
  large: BASE_OFFSET_VALUE * 4,
  xlarge: BASE_OFFSET_VALUE * 5,
  full: BASE_OFFSET_VALUE * 25,
};

export const border_radius_styles_with_size: Record<BorderRadiusSize, number> = {
  xsmall: BASE_OFFSET_VALUE,
  small: BASE_OFFSET_VALUE * 2,
  medium: BASE_OFFSET_VALUE * 3,
  large: BASE_OFFSET_VALUE * 4,
  xlarge: BASE_OFFSET_VALUE * 5,
  full: BASE_OFFSET_VALUE * 25,
};

export const shadow_styles_with_scale: Record<ShadowScale, string> = {
  low: `0 4px 16px rgba(0, 0, 0, 0.1)`,
  medium: `0 8px 24px rgba(0, 0, 0, 0.16)`,
  high: `0 12px 40px rgba(0, 0, 0, 0.2)`,
};

function getShadowStyle(usage_with_scale: ShadowScale): `box-shadow: ${string};` {
  return `box-shadow: ${shadow_styles_with_scale[usage_with_scale]};`;
}

export const shapes: Shapes = {
  border_radius: {
    xsmall: getBorderRadiusStyle('xsmall'),
    small: getBorderRadiusStyle('small'),
    medium: getBorderRadiusStyle('medium'),
    large: getBorderRadiusStyle('large'),
    xlarge: getBorderRadiusStyle('xlarge'),
    full: getBorderRadiusStyle('full'),
  },
  shadow: {
    low: getShadowStyle('low'),
    medium: getShadowStyle('medium'),
    high: getShadowStyle('high'),
  },
};
